import Glide from "@glidejs/glide";
import { adminEventListeners } from "./admin";

import { CustomCheckoutFieldListeners } from "./customCheckoutFields";

document.addEventListener("DOMContentLoaded", function() {
  adminEventListeners();
  CustomCheckoutFieldListeners();

  if (/.jumbonunspeet.nl\/$/.test(window.location.href.toLowerCase())) {
    new Glide(".glide", {
      type: "carousel",
      gap: 100,
      animationDuration: 1000,
      autoplay: 5000,
    }).mount();
  }

  const overlay = document.querySelector(".woocommerce-notices-wrapper");
  if (overlay) {
    overlay.addEventListener("click", () => {
      overlay.classList.add("hidden");
    });
  }

  if (/.jumbonunspeet.nl\/contact\/$/.test(window.location.href.toLowerCase())) {
    var name = document.getElementsByName("your-name")[0];
    var mail = document.getElementsByName("your-email")[0];
    var message = document.getElementsByName("your-message")[0];
    name.addEventListener("input", () => {
      if (name.value != "" && /\S+@\S+\.\S+/.test(mail.value) && message.value != "") {
        document.querySelector(".wpcf7-form-control.wpcf7-submit").classList.add("active");
      } else {
        document.querySelector(".wpcf7-form-control.wpcf7-submit").classList.remove("active");
      }
    });
    mail.addEventListener("input", () => {
      if (name.value != "" && /\S+@\S+\.\S+/.test(mail.value) && message.value != "") {
        document.querySelector(".wpcf7-form-control.wpcf7-submit").classList.add("active");
      } else {
        document.querySelector(".wpcf7-form-control.wpcf7-submit").classList.remove("active");
      }
    });
    message.addEventListener("input", () => {
      if (name.value != "" && /\S+@\S+\.\S+/.test(mail.value) && message.value != "") {
        document.querySelector(".wpcf7-form-control.wpcf7-submit").classList.add("active");
      } else {
        document.querySelector(".wpcf7-form-control.wpcf7-submit").classList.remove("active");
      }
    });
  }

  if (window.location.href.indexOf("#") !== -1) {
    var urlArray = window.location.href.split("#");

    let target = document.getElementById(urlArray[1]);
    if (target) {
      var top = target.offsetTop + 15;

      window.scrollTo({
        behavior: "smooth",
        left: 0,
        top: top,
      });
    }
  }

  var urlArray = window.location.href.split("#");
  var subjectArray = urlArray[0].split("/");
  var button = document.getElementById(subjectArray[3] + "-button-" + urlArray[1]);
  if (button) {
    openCollapsable(button);
  }

  /**
   * Menu
   */

  var menuButton = document.getElementById("menu_burger");
  if (menuButton) {
    menuButton.addEventListener("click", () => {
      var menu = document.getElementById("mobile-menu");
      menu.classList.toggle("active");
      document.getElementsByTagName("body")[0].classList.toggle("overflow-hidden");
    });
  }

  var menuCloseButton = document.getElementById("mobile-menu-close");
  if (menuCloseButton) {
    menuCloseButton.addEventListener("click", () => {
      var menu = document.getElementById("mobile-menu");
      menu.classList.toggle("active");
      document.getElementsByTagName("body")[0].classList.toggle("overflow-hidden");
    });
  }

  var menuDropdown = document.querySelector("#mobile-menu .menu-item-has-children");
  if (menuDropdown) {
    menuDropdown.addEventListener("click", () => {
      var content = menuDropdown.querySelector(".sub-menu");

      var isCollapsed = content.getAttribute("data-collapsed") === "true";

      if (isCollapsed) {
        expandSection(content);
        content.setAttribute("data-collapsed", "false");
      } else {
        collapseSection(content);
      }
    });
  }
  // start menu collapsed
  if (menuDropdown) {
    var content = menuDropdown.querySelector(".sub-menu");
    if (content) {
      collapseSection(content);
    }
  }
  /**
   *
   */

  var nieuwsToggleButtons = document.querySelectorAll("[id ^= 'nieuws-button-']");
  var actiesToggleButtons = document.querySelectorAll("[id ^= 'acties-button-']");
  var verbouwingToggleButtons = document.querySelectorAll("[id ^= 'verbouwing-button-']");

  [...nieuwsToggleButtons, ...actiesToggleButtons, ...verbouwingToggleButtons].forEach((button) => {
    var selector = button.id
      .replace("nieuws-button-", "nieuws-content-")
      .replace("acties-button-", "acties-content-")
      .replace("verbouwing-button-", "verbouwing-content-");

    var content = document.getElementById(selector);

    if (content.scrollHeight - 10 <= content.getAttribute("data-target")) {
      button.classList.add("hidden");
    }
  });

  [...nieuwsToggleButtons, ...actiesToggleButtons, ...verbouwingToggleButtons].forEach((button) => {
    button.addEventListener("click", function(e) {
      openCollapsable(button);
    });
  });

  var voordeelToggleButtons = document.querySelectorAll("[id ^= 'voordeel-button-']");

  [...voordeelToggleButtons].forEach((button) => {
    button.addEventListener("click", function(e) {
      button.classList.toggle("bg-yellow");
      var selector = button.id
        .replace("voordeel-button-", "voordeel-content-")
        .replace("zeker-button-", "zeker-content-");

      var content = document.getElementById(selector);
      var isCollapsed = content.getAttribute("data-collapsed") === "true";

      if (isCollapsed) {
        expandSection(content);
        content.setAttribute("data-collapsed", "false");
      } else {
        collapseSection(content, 0);
      }

      var arrowSelector = document.getElementById(
        button.id.replace("voordeel-button-", "voordeel-image-").replace("zeker-button-", "zeker-content-")
      );

      arrowSelector.classList.toggle("rotate-270");
    });
  });

  let firstButton = document.querySelector("[id ^= 'nieuws-button-']");
  if (firstButton) {
    firstButton.click();
  }

  firstButton = document.querySelector("[id ^= 'acties-button-']");
  if (firstButton) {
    firstButton.click();
  }

  firstButton = document.querySelector("[id ^= 'voordeel-button-']");
  if (firstButton) {
    firstButton.click();
  }

  var cookieOk = document.getElementById("cookie-button-ok");
  if (cookieOk) {
    cookieOk.addEventListener("click", () => {
      var date = new Date();
      date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);

      document.cookie = "cookie_notice=ok; expires=T" + date.toUTCString() + ";  path=/;";
      document.getElementById("cookie-notice").classList.add("translate-y-full");
    });
  }

  var cookieClose = document.getElementById("cookie-button-close");
  if (cookieClose) {
    cookieClose.addEventListener("click", () => {
      var date = new Date();
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
      document.cookie = "cookie_notice=ok; expires=T" + date.toUTCString() + ";  path=/;";
      document.getElementById("cookie-notice").classList.add("translate-y-full");
    });
  }
});

function collapseSection(element, till = 0) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;

  // temporarily disable all css transitions
  var elementTransition = element.style.transition;
  element.style.transition = "";

  // on the next frame (as soon as the previous style change has taken effect),
  // explicitly set the element's height to its current pixel height, so we
  // aren't transitioning out of 'auto'
  requestAnimationFrame(function() {
    element.style.height = sectionHeight + "px";
    element.style.transition = elementTransition;

    // on the next frame (as soon as the previous style change has taken effect),
    // have the element transition to height: 0
    requestAnimationFrame(function() {
      element.style.height = till + "px";
    });
  });

  // mark the section as "currently collapsed"
  element.setAttribute("data-collapsed", "true");
}

function expandSection(element) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;

  // have the element transition to the height of its inner content
  element.style.height = sectionHeight + "px";

  // when the next css transition finishes (which should be the one we just triggered)
  element.addEventListener(
    "transitionend",
    function(e) {
      // remove "height" from the element's inline styles, so it can return to its initial value
      element.style.height = null;
    },
    {
      once: true,
    }
  );

  // mark the section as "currently not collapsed"
  element.setAttribute("data-collapsed", "false");
}

function openCollapsable(button) {
  button.classList.toggle("rotate-180");

  var selector = button.id
    .replace("nieuws-button-", "nieuws-content-")
    .replace("acties-button-", "acties-content-")
    .replace("verbouwing-button-", "verbouwing-content-");

  var content = document.getElementById(selector);
  var isCollapsed = content.getAttribute("data-collapsed") === "true";

  if (isCollapsed) {
    expandSection(content);
    content.setAttribute("data-collapsed", "false");
  } else {
    collapseSection(content, content.getAttribute("data-target"));
  }
}
